import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem, IonLabel, IonRadio, IonRadioGroup } from "@ionic/react";
import React, { useState } from "react";
import { useIsMobile } from "../../../../../Responsive";
import SettingsTextInput from "../../../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import style from "../../LicenseSettings.module.scss";
import { Item, MobileContainer, Wrapper } from "../Wrapper/Wrapper";
import { LSTCompanyChoicePopoverProps } from "./types";


function hasKeys(obj: Record<any, any>)
{
    return Object.keys(obj).length > 0;
}

export const Content: React.FC<
    {
        companyLocation: LSTCompanyChoicePopoverProps["data"],
        onData: LSTCompanyChoicePopoverProps["onData"],
        onChange: LSTCompanyChoicePopoverProps["onChange"],
        onDismiss: LSTCompanyChoicePopoverProps["onDismiss"],
        onOpenInvoiceAddress: LSTCompanyChoicePopoverProps["onOpenInvoiceAddress"],
    }> = ({
        companyLocation,
        onData,
        onChange,
        onDismiss,
        onOpenInvoiceAddress
    }) =>
    {
        const mobileView = useIsMobile();
        const { translate: t } = useL10n();
        const [disabled, setDisabled] = useState(true);
        return <>
            <Wrapper className={`${style.paddingTop5} ${style.center} ${style.column}`}>
                <MobileContainer
                    className={`${style.width100} ${style.center}`}
                >
                    <MobileContainer
                        className={`${style.width80}`}
                    >
                        <IonRadioGroup
                            value={companyLocation.company || null}
                            className={`${style.radioGroup} ${style.paddingTop30}`}
                            style={{ whiteSpace: "wrap" }}
                            onIonChange={({ detail }) =>
                            {
                                //const data = { company: detail.value };
                                companyLocation.company = detail.value;
                                onChange(companyLocation);
                                // if (!detail.value) {
                                //     delete data.company;
                                // }
                                setDisabled(!detail.value);
                            }}>
                            <IonRadio
                                labelPlacement={"end"}
                                alignment="center"
                                value={null}>
                                {t("[REACT_NO_CUSTOMER]")}
                            </IonRadio>
                            <br />
                            <IonRadio
                                labelPlacement={"end"}
                                alignment="center"
                                value={"Austria"}>
                                <span
                                    className={mobileView ? style.brakeWord : ""}
                                >Labor Strauss Sicherungsanlagenbau GmbH, {t("COM_USERS_GROUP_COUNTRY_AUT")}
                                </span>
                            </IonRadio>
                            <br />
                            <IonRadio
                                labelPlacement={"end"}
                                alignment="center"
                                value={"Germany"}>
                                <span
                                    className={mobileView ? style.brakeWord : ""}
                                >LST-Deutschland GmbH, {t("COM_USERS_GROUP_COUNTRY_DEU")}
                                </span>
                            </IonRadio>
                        </IonRadioGroup>
                    </MobileContainer>
                </MobileContainer>
            </Wrapper >
            <MobileContainer className={`${style.width100} ${style.center}`}>
                <MobileContainer
                    className={`${style.width80} `}
                >
                    <Wrapper className={`${style.center}  `}>
                        <Wrapper className={`${style.width50}  `}>
                            <SettingsTextInput
                                text={"COM_VMINVOICE3_CUSTOMER_NUMBER"}
                                inputType="number"
                                value={companyLocation?.invoiceAccountNumber && !isNaN(Number(companyLocation.invoiceAccountNumber)) ? companyLocation.invoiceAccountNumber : ""}
                                onChange={(invoiceAccountNumber) =>
                                {
                                    companyLocation.invoiceAccountNumber = invoiceAccountNumber;

                                    if ((invoiceAccountNumber).length === 6) {
                                        setDisabled(false);
                                        onChange(companyLocation);
                                    } else {
                                        setDisabled(true);
                                    }
                                }}
                            />
                        </Wrapper>
                    </Wrapper>
                </MobileContainer>
            </MobileContainer>
            <div className={`${style.center} ${style.padding20} ${style.column} ${style.textCenter}`}>
                <Item lines={"none"} className={style.width100}>
                    <Wrapper className={`${style.center} ${style.width100} ${style.marginTop15}`}>
                        <MobileContainer className={style.width100}>
                            <IonButton
                                disabled={disabled}
                                expand={mobileView ? "full" : undefined}
                                color={"success"}
                                onClick={() =>
                                {
                                    companyLocation && onData(companyLocation);
                                }}
                            >
                                {t("COM_MAILTO_SEND")}
                            </IonButton>
                        </MobileContainer>
                    </Wrapper>
                </Item>
                <IonItem>
                    <Wrapper className={`${style.center} ${style.textCenter} ${style.padding5}`}>
                        <IonLabel
                            className={` ${style.padding10} ${style.width80} ${mobileView ? `${style.paddingTop} ${style.textCenter}` : ""}`}
                        > {t("[REACT_SUBMIT_INVOICE_ADDRESS]", { country: t("COM_USERS_GROUP_COUNTRY_AUT") })}
                        </IonLabel>
                    </Wrapper>
                </IonItem>
            </div>
            <Item lines={"none"}>
                <div className={`${style.center} ${style.padding20} ${style.column} ${style.textCenter}`}>
                    <MobileContainer className={`${style.center}`}>
                        <IonItem lines="none">
                            <IonLabel
                                className={` ${style.padding10} ${style.width80} ${mobileView ? `${style.paddingTop} ${style.textCenter}` : ""}`}
                            >
                                {t("[REACT_SUBMIT_NOT_CUSTOMER_JET]")}
                            </IonLabel>
                        </IonItem>
                    </MobileContainer>
                    <MobileContainer className={`${style.width100} ${style.paddingTop10}`}>
                        <IonButton
                            expand={mobileView ? "full" : undefined}
                            disabled={!disabled}
                            color={"medium"}
                            onClick={() =>
                            {
                                onOpenInvoiceAddress();
                                onDismiss();
                            }}
                        >
                            {t("[REACT_ENTER_INVOICE_ADDRESS]")}
                        </IonButton>
                        <IonItem lines="full">
                            <IonLabel
                                className={` ${style.padding10} ${style.width100} ${mobileView ? `${style.paddingTop} ${style.textCenter}` : ""}`}
                            >
                                {t("REACT_LICENSE_NOTE")}
                            </IonLabel>
                        </IonItem>
                    </MobileContainer>
                </div>
            </Item>
        </>;
    };